export type PositionResponse = {
  "db/id"?: string;
  "position/display-name": string;
  "credentialRequired?"?: boolean;
  "position/long-term-pay-rate"?: string;
  "position/pay-rate"?: string;
  "position/sub-name"?: string;
};

export class PositionModel {
  private position;

  constructor(position: PositionResponse) {
    this.position = position;
  }

  get id(): string {
    return this.position?.["db/id"] || "";
  }

  get displayName() {
    return this.position?.["position/display-name"] || "";
  }

  get credsRequired() {
    return this.position?.["credentialRequired?"] || false;
  }

  get longTermPayRate() {
    return this.position?.["position/long-term-pay-rate"] || "";
  }

  get payRate() {
    return this.position?.["position/pay-rate"] || "";
  }

  get subName() {
    return this.position?.["position/sub-name"] || ";";
  }
}
